import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as React from 'react'
import { connect } from 'react-redux'
import cardStyles from '../../components/Card/card.scss'
import { Radio, RadioGroup } from '../../components/Radio'
import { dispatch, Dispatch, RootState } from '../../store'
import paymentStyles from './payment-page.scss'

import radioStyles from '../../components/Radio/radio.scss'

const cx = classnames.bind({
  ...cardStyles,
  ...radioStyles,
  ...paymentStyles
})

interface IProps
  extends ReturnType<typeof mapState>,
    ReturnType<typeof mapDispatch> {
  lecture: ILecture | null
}

class PaymentPageMain extends React.Component<IProps> {
  public componentWillReceiveProps = (nextProps: IProps) => {
    const { lecture } = nextProps
    // just receive lecture
    if (
      this.props.lecture === null &&
      lecture &&
      firebase.firestore.Timestamp.now() < lecture.soldAt
    ) {
      dispatch.payment.updateDiscountType('earlybird')
      dispatch.payment.checkout()
    }
  }
  public componentDidMount = () => {
    const { lecture } = this.props
    if (lecture && firebase.firestore.Timestamp.now() < lecture.soldAt) {
      dispatch.payment.updateDiscountType('earlybird')
      dispatch.payment.checkout()
    }
  }
  public render() {
    const {
      lecture,
      payment,
      onPaymentTypeChange,
      onCouponChange,
      onDiscountTypeChange,
      // onInvoiceTypeChange,
      onCouponCheck,
      // onCitizenDigiCertChange,
      // onMobileBarcodeChange,
      // onNameChange,
      // onEmailChange
    } = this.props
    const {
      paymentType,
      couponId,
      couponError,
      discountType,
      couponDiscount,
      // invoiceType
    } = payment
    return (
      <div className={cx('card', 'card--rounded-4', 'page-Payment__main')}>
        <div className={cx('payment-form__section')}>
          <RadioGroup
            label="選擇付款方式"
            name="paymentType"
            onChange={onPaymentTypeChange}
            selectedValue={paymentType}
          >
            <Radio
              label="信用卡（VISA、MasterCard、JCB 卡及銀聯卡）"
              value="CREDIT"
            />
            <Radio label="ATM 轉帳" value="VACC" />
            <Radio
              label="超商付款 （手續費 NT$ 30，若募資失敗 30 元將不進行退款"
              value="BARCODE"
            />
          </RadioGroup>
        </div>
        <hr />
        {/* <div className={cx('payment-form__section')}>
          <h6 className={cx('payment-form__title')}>電子發票選項</h6>
          <ol className={cx('payment-form__description')}>
            <li>以下資訊只用於開立發票，Qraft 將全力保護您的個人資料。</li>
            <li>請注意！資料填寫後不可更改，填寫個人資料以確保課程發票、相關教材、票券或是購課贈品能正確寄出。</li>
          </ol>
          <RadioGroup
            label=""
            onChange={onInvoiceTypeChange}
            selectedValue={invoiceType}>
            <Radio label="將發票儲存在 Qraft（中獎後自動寄信通知您）" value="1" />
            <Radio label="自然人憑證條碼" value="2" />
            {
              invoiceType === '2' ? (
                <div className={cx('item')}>
                  <input
                    onChange={onCitizenDigiCertChange}
                    className={cx('input', 'input--fluid')}
                    type="text" placeholder="共16個字元，由2碼大寫字母加14碼數字組成" />
                </div>
              ) : null
            }
            <Radio label="手機條碼" value="3" />
            {
              invoiceType === '3' ? (
                <div className={cx('item')}>
                  <input
                    onChange={onMobileBarcodeChange}
                    className={cx('input', 'input--fluid')}
                    type="text" placeholder="共7個字元，由“/”加上7碼 +、-、.、數字及大寫字母組成" />
                </div>
              ) : null
            }
          </RadioGroup>
          <ul className={cx('payment-form__personal-info')}>
            <li className={cx('item')}>
              <label className={cx('label')} htmlFor="">姓名 <span>*</span></label>
              <input className={cx('input')} type="text" placeholder="請填寫真實姓名" required={true} onChange={onNameChange} />
            </li>
            <li>
              <label className={cx('label')} htmlFor="">聯絡用電子信箱 <span>*</span></label>
              <input className={cx('input')} type="text" placeholder="請填寫電子信箱" required={true} onChange={onEmailChange} />
            </li>
          </ul>
        </div>
        <hr /> */}
        <div className={cx('payment-form__section')}>
          <RadioGroup
            label="使用折扣"
            name="discountType"
            onChange={onDiscountTypeChange}
            selectedValue={discountType}
          >
            <Radio label="無" value="none" />
            {lecture && firebase.firestore.Timestamp.now() < lecture.soldAt ? (
              <Radio label="使用早鳥優惠" value="earlybird" />
            ) : null}
            <Radio label="Coupon優惠" value="coupon" />
            {discountType === 'coupon' ? (
              <div>
                <div className={cx('radio-item__show-flex')}>
                  <input
                    name="couponId"
                    autoFocus={true}
                    className={cx('input', 'input--error')}
                    type="text"
                    onChange={onCouponChange}
                    value={couponId}
                    placeholder="請輸入Coupon序號"
                  />
                  <button
                    className={cx('btn', 'btn--lg', 'btn--primary', 'u-ml-8')}
                    onClick={onCouponCheck}
                  >
                    確認
                  </button>
                </div>
                {couponError ? (
                  <span className={cx('para--sm', 'color--error')}>
                    *這個 Coupon 代碼不存在喔！
                  </span>
                ) : null}
                {couponDiscount ? (
                  <span className={cx('para--sm', 'color--success')}>
                    折扣 {couponDiscount}
                  </span>
                ) : null}
              </div>
            ) : null}
          </RadioGroup>
        </div>
      </div>
    )
  }
}

const mapState = ({ payment }: RootState) => ({
  payment
})

// tslint:disable-next-line:variable-name
const mapDispatch = (_dispatch: Dispatch) => ({
  onCouponCheck: _dispatch.payment.checkCoupon,
  onPaymentTypeChange: (event: React.FormEvent<HTMLInputElement>) => {
    _dispatch.payment.updatePaymentType(event.currentTarget.value)
    _dispatch.payment.checkout()
  },
  onDiscountTypeChange: (event: React.FormEvent<HTMLInputElement>) => {
    _dispatch.payment.updateDiscountType(event.currentTarget.value)
    _dispatch.payment.checkout()
  },
  onInvoiceTypeChange: (event: React.FormEvent<HTMLInputElement>) => {
    _dispatch.payment.updateInvoiceType(event.currentTarget.value)
  },
  onCouponChange: (event: React.ChangeEvent<HTMLInputElement>) => {
    _dispatch.payment.updateCoupon(event.currentTarget.value)
  },
  onCitizenDigiCertChange: (event: React.ChangeEvent<HTMLInputElement>) => {
    _dispatch.payment.updateCitizenDigiCert(event.currentTarget.value)
  },
  onMobileBarcodeChange: (event: React.ChangeEvent<HTMLInputElement>) => {
    _dispatch.payment.updateMobileBarcode(event.currentTarget.value)
  },
  onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => {
    _dispatch.payment.updateName(event.currentTarget.value)
  },
  onEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => {
    _dispatch.payment.updateEmail(event.currentTarget.value)
  }
})
export default connect(
  mapState,
  mapDispatch
)(PaymentPageMain)



// WEBPACK FOOTER //
// ./src/pages/PaymentPage/main.tsx